import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { User } from '../models/user.model';
import { Role } from '../models/role';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { MatSnackBar, MatSnackBarConfig, MatDialog, MatDialogRef } from '@angular/material';
import { ConfirmationDialogComponent } from '../dialog/confirmation-dialog/confirmation-dialog.component';
import { Router } from '@angular/router';

@Injectable()
export class UserService {

  usersLink = environment.usersLink;

  casesLink = environment.casesLink;

  apiService: ApiService = new ApiService(this.http);
  dialogRef: any;

  constructor(
    private http: Http,
    public dialog: MatDialog,
    private router: Router

  ) { }

  // GET : User Role for Dashboard
  //   getUserRoleForDashboard() {
  //       return this.apiService.getCall('./assets/data/userRole.json');
  //   }

  getUser(sub: string) {
    return this.apiService.getCall('usersLink', `users/${sub}`);
  }

  getUserById(orgId, userId) {
    // return this.apiService.getCall('casesLink', `organization/${orgId}/users/${userId}/cases`);
    return this.apiService.getCall('casesLink', `users/${userId}/cases`);
  }

  postUserOrg(user, org: string) {
    return this.apiService.postCall('usersLink', `organizations/${org}/linkusers`, user);
  }

  postUserInOrg(user, org) {
    return this.apiService.postCall('usersLink', `organizations/${org}/users`, user);
  }

  linkUserToCase(orgId: string, caseId: string, user: any) {
    // return this.apiService.postCall('casesLink', `organizations/${orgId}/cases/${caseId}/link`, user);
    return this.apiService.postCall('casesLink', `cases/${caseId}/link`, user);
  }

  getUsersByRole(orgId: string, role: Role): Observable<User[]> {
    return this.apiService.getCall('usersLink', `organizations/${orgId}/roles/${role}`);
  }

  deleteUser(userId: string) {
    return this.apiService.deleteCall('usersLink', `users/${userId}`);
  }

  updateUser(userId, user, orgId) {
    return this.apiService.patchCallUser(`${this.usersLink}organizations/${orgId}/users/${userId}`, user);
  }

  getUserPrefrence(userId) {
    return this.apiService.getCall('usersLink', `users/${userId}`);
  }

  getUserByEmail(email) {
    return this.apiService.getCall('usersLink', `user/${email}`);
  }

  // background api

  postUserBackgroundRequest(orgId, userId, data) {
    return this.apiService.postCall('usersLink', `${orgId}/background/${userId}`, data);
  }

  postUserBackgroundProcess(orgId, userId) {
    return this.apiService.postCall('usersLink', `/${orgId}/background/${userId}/order`, {});
  }

  getMultipleUserDetails(userIds: string[]) {
    if(userIds){
      return this.apiService.getCall('usersLink', `users?userIds=${userIds}`)
    }
    
  }
  confirmUserUpdate(userId) {
    return this.apiService.putCall('usersLink', `users/${userId}/confirm`)
  }

  getAllUserDetails(userIds: string[]) {
    return this.apiService.getCall('usersLink', `users/${userIds}`)
  }
  postUserPaymentPreferences(userId, data) {
    return this.apiService.postCall('usersLink', `users/${userId}/payment`, data);
  }

  //TODO: See where we can write this user related common logic other than service
  convertUserObjectToModel(apiResultObj: any, userToSaved: any) {
        userToSaved.address = apiResultObj.address || null;
        if (userToSaved.role.toLowerCase() === 'guardian') {
          userToSaved.background_id = apiResultObj.background_id || null;
          userToSaved.background_package = apiResultObj.background_package || null;
          userToSaved.background_status = apiResultObj.background_status || null;
          userToSaved.background_report_id = apiResultObj.background_report_id || null;
        }
        userToSaved.birth_date = apiResultObj.birth_date || null;
        userToSaved.city = apiResultObj.city || null;
        userToSaved.contact_preference = apiResultObj.contact_preference || null;
        userToSaved.created_date = apiResultObj.created_date || null;
        userToSaved.email = apiResultObj.email || null;
        userToSaved.first_name = apiResultObj.first_name || null;
        userToSaved.middle_name = apiResultObj.middle_name || null;
        userToSaved.last_name = apiResultObj.last_name || null;
        userToSaved.modified_date = apiResultObj.modified_date || null;
        userToSaved.phone_number = apiResultObj.phone_number || null;
        userToSaved.state = apiResultObj.state || null;
        userToSaved.status = apiResultObj.status || null;
        userToSaved.user_name = apiResultObj.user_name || null;
        userToSaved.zip = apiResultObj.zip || null;
        userToSaved.paymentPref = null;
        if (apiResultObj.payment_preference !== null) {
          // Saving payment preferences
          userToSaved.paymentPref = apiResultObj.payment_preference || null;
        }
        return userToSaved;
  }

  getPaymentPrefValueToSet(actualValue: string) {
    let valueToReturn: string = null;
    switch (actualValue) {
      case 'ACH_MICRO_DEPOSITS':
        valueToReturn = 'ACH_MICRO';
        break;
      case 'ACH_INSTANT_PAY':
        valueToReturn = 'ACH_INSTANT';
        break;
      case 'CREDIT_CARD':
        valueToReturn = 'CC';
        break;
      case 'PAY_IN_PERSON':
        valueToReturn = 'CHECK';
        break;
      default:
        valueToReturn = null;
        break;
    }
    return valueToReturn;
  }

  getUserPaymentPrefDisplayValue(actualValue: string) {
    let valueToReturn: string = null;
    switch (actualValue) {
      case 'ACH_MICRO_DEPOSITS':
        valueToReturn = 'ACH - Micro deposits';
        break;
      case 'ACH_INSTANT_PAY':
        valueToReturn = 'ACH- Instant Verification';
        break;
      case 'CREDIT_CARD':
        valueToReturn = 'Credit Card / Debit Card ';
        break;
      case 'PAY_IN_PERSON':
        valueToReturn = 'Pay in person';
        break;
      default:
        valueToReturn = null;
        break;
    }
    return valueToReturn;
  }

  checkIfUserPaymentPreferenceSet(userObj: any) {
    if (userObj.paymentPref == null && (userObj.role=='GUARDIAN' || userObj.role=='PETITIONER' || userObj.role=='ATTORNEY')) {
      this.dialogRef = this.dialog.open(ConfirmationDialogComponent,{
        panelClass:"confirmDetails",
        width:'600px'
      });
      this.dialogRef.componentInstance.title = 'PAYMENT PREFERENCE';
      this.dialogRef.componentInstance.successButtonText = 'CONFIGURE';
      this.dialogRef.componentInstance.errorButtonText = "DO NOT CONFIGURE";
      this.dialogRef.componentInstance.achCheck = true;
      this.dialogRef.componentInstance.msg = "eGuard supports following payment options \n\u2022 Credit Card \n\u2022 Debit Card and  \n\u2022 ACH[Automated Clearing House].\nPayment preferences can be managed under settings.";
      this.dialogRef.afterClosed()
        .subscribe(response => {
          if (response || response == 'DONT_REMIND') {
            this.postUserPaymentPreferences(userObj.id,
              {
                paymentType :"DONT_REMIND"
              })
                .subscribe(preferenceSaved => {
                  console.log(preferenceSaved);
                  if(response != 'DONT_REMIND'){
                    this.router.navigate(['/settings'], {queryParams:{payments:true}});
                  }
                });            
          }
          if (!response) {
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/user.service.ts